import { FieldModel } from '@cibo/core'
import { TillageCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface TillageCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const TillageCell = ({ value, task, year, selectedField }: TillageCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="tillage"
    >
      <TillageCellDisplay value={value} />
    </TraitCellContainer>
  )
}
